import React, { useState } from "react";
import { motion } from "framer-motion";
import CustomAction from "../../../../controls/CustomAction";
import businessOption from "../../../../../Assets/business-opt.png";
import adventureOption from "../../../../../Assets/adventure-opt.png";
import holidayOption from "../../../../../Assets/holiday-opt.png";
import pilgrimageOption from "../../../../../Assets/pilgrimage-opt.png";
import gapYearOption from "../../../../../Assets/gapyear-opt.png";
import otherOption from "../../../../../Assets/other-opt.png";
import { TbCircleDotFilled } from "react-icons/tb";
import Flag from "react-world-flags";
import { setOptions } from "leaflet";

export default function TripPurpose({
  mainColor,
  tripSelections,
  setTripSelections,
  handleNextStepPC,
  countryName,
  countryCode,
}) {
  const options = [
    {
      iconSrc: businessOption,
      title: "Business",
    },
    {
      iconSrc: adventureOption,
      title: "Adventure",
    },
    {
      iconSrc: holidayOption,
      title: "Holiday",
    },
    {
      iconSrc: pilgrimageOption,
      title: "Pilgrimage",
    },
    {
      iconSrc: gapYearOption,
      title: "Gap Year",
    },
    {
      iconSrc: otherOption,
      title: "Other",
    },
  ];

  const handleOptionsClick = (option) => {
    setTripSelections((prev) => {
      const existing = prev?.tripPurpose || [];
      const filtered = existing?.filter((item) => item.country !== countryName);
      return {
        ...prev,
        tripPurpose: [...filtered, { country: countryName, option: option }],
      };
    });
  };

  const handleContinue = () => {
    handleNextStepPC();
  };
  return (
    <motion.div
      initial={{ y: 50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ type: "spring", stiffness: 100, delay: 0.5 }}
      exit={{ y: 50, opacity: 0 }}
      className="bf-content-wrapper pc-trip-purpose"
    >
      <div className="bf-content-header">
        <h2 className="bf-title" style={{ color: mainColor }}>
          Trip Purpose for {countryName}
          <div className="flag-container">
            <Flag code={countryCode} />
          </div>
        </h2>
        <p className="bf-subtitle">
          Why we ask: Your trip type affects health risks—business travelers may
          have different needs from adventure seekers.
        </p>
      </div>

      <div className="bf-content-body">
        <div className="options-wrapper">
          {options.map((option) => {
            const isSelected = tripSelections?.tripPurpose?.some(
              (item) =>
                item.country === countryName && item.option === option.title
            );

            return (
              <div
                className={`option ${isSelected ? "selected" : ""}`}
                style={{
                  border: isSelected
                    ? `1px solid ${mainColor}`
                    : "1px solid #cecece",
                }}
                onClick={() => handleOptionsClick(option.title)}
                key={option.title}
              >
                <div className="icon-title">
                  <div>
                    <img src={option.iconSrc} alt="icon" />
                  </div>
                  <p>{option.title}</p>
                </div>

                {isSelected ? (
                  <TbCircleDotFilled
                    className="checkmark"
                    color={mainColor}
                    size={22}
                  />
                ) : (
                  <div className="empty-circle"></div>
                )}
              </div>
            );
          })}
        </div>
        <CustomAction mainColor={mainColor} text={"Continue"} action={handleContinue} />
      </div>
    </motion.div>
  );
}
